var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LineChartGenerator", {
    attrs: {
      "chart-id": _vm.chart_id,
      "chart-data": _vm.chartData,
      "chart-options": _vm.chart_options,
      width: _vm.width,
      height: _vm.height,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }